import axios from "axios";

export const loadAllMeetingReportsAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?limit=${payload.pageSize}&countries=[${
        payload.selectedCountries
      }]&objectId=${payload.objectId}&objectType=${payload.objectType}&page=${
        payload.currentPage
      }&orderBy=${payload.sort ? payload.sort.dir : "desc"}&status=${
        payload.status
      }&orderColumn=${payload.sort ? payload.sort.column : "id"}&search=${
        payload.search ?? ""
      }`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleMeetingReportAPI = (payload) => {
  return axios
    .get(`/meetingReports/${payload.meetingReportId}`, {
      headers: {
        Accept: "application/json",
      },
    })
    .then((res) => res.data);
};
